import React, { useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";
import '../styles/footer.css';
import popup from "../images/10.png";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import jazzicon from "@metamask/jazzicon";

const Header = (props) => {
const avatarRef = useRef();

useEffect(() => {
    const element = avatarRef.current;
    if (element && props.blockchain.account) {
        const addr = props.blockchain.account.slice(2, 10);
        const seed = parseInt(addr, 16);
        const icon = jazzicon(20, seed); //generates a size 20 icon
        if (element.firstChild) {
            element.removeChild(element.firstChild);
        }
        element.appendChild(icon);
    }
}, [props.blockchain.account, avatarRef]);

  return (
    <div>
      <nav className="navbar navbar-expand-md navbar-dark bg-dark">
        <div className="container-fluid">
          <a className="navbar-brand" href="/">
            NFT
          </a>
          <div ref={avatarRef}></div>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarText"
            aria-controls="navbarText"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          {/* <div className="collapse navbar-collapse" id="navbarText">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
             
              <li
                className="nav-item"
                type="button"
                data-bs-toggle="modal"
                data-bs-target="#staticBackdrop"
              >
                <span className="nav-link">Checkers</span>
              </li>
             

            </ul>
          </div> */}
        </div>
      </nav>

      {/* <!--Modal --> */}

      <div
        className="modal fade mt-3"
        id="staticBackdrop"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog ">
          <div className="modal-content">
            <div className="modal-header">
              <h3
                className="modal-title"
                id="staticBackdropLabel"
                style={{ fontSize: "20px" }}
              >
                Do you want to challenge for?
              </h3>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div
              className="modal-body text-center"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="NFT Coming Soon..."
            >
              <img src={popup} width="300px" height="300px" alt="popup"/>
            </div>
            <div className="modal-footer  justify-content-between">
              <a href="/checkers" className="">
                <button
                  type="button"
                  className="btn btn-success "
                  data-bs-dismiss="modal"
                >
                  Free
                </button>
              </a>
              <div tabIndex="0" data-bs-toggle="tooltip" title="Coming soon...">
              <button type="button" className="btn btn-primary ">
                  <NavLink
                    className="text-light text-decoration-none"
                    aria-current="page"
                    to="/nftpaid"
                  >
                    NFT Coming-Soon
                  </NavLink>
                </button>
               
              
              </div>
            </div>
            
          </div>
        </div>
      </div>
      {/* Pool */}
      <div
        className="modal fade mt-3"
        id="staticBackdrop-2"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog ">
          <div className="modal-content">
            <div className="modal-header">
              <h3
                className="modal-title"
                id="staticBackdropLabel"
                style={{ fontSize: "20px" }}
              >
                Do you want to challenge for?
              </h3>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div
              className="modal-body text-center"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="NFT Coming Soon..."
            >
              <img src={popup} width="300px" height="300px" alt="popup"/>
            </div>
            <div className="modal-footer  justify-content-between">
              <a href="/pool" className="">
                <button
                  type="button"
                  className="btn btn-success "
                  data-bs-dismiss="modal"
                >
                  Free
                </button>
              </a>
              <div tabIndex="0" data-bs-toggle="tooltip" title="Coming soon...">
                <button type="button" className="btn btn-primary ">
                  <NavLink
                    className="text-light text-decoration-none"
                    aria-current="page"
                    to="/nftpaid"
                  >
                    NFT Coming-Soon
                  </NavLink>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = state => {
  const { blockchain} = state
  return { blockchain }
}

export default connect(mapStateToProps, {})(Header)


Header.propTypes = {
  errorMsg: PropTypes.any,
  account: PropTypes.any,
  history: PropTypes.object
}
//export default Header;
